/*
 * Woolie — Combo "compre junto" (add-ons inline, 1 checkbox por variante).
 * Quando há add-on(s) marcado(s), intercepta o submit do formulário de produto
 * (em capture, antes do product-form.js) e adiciona a variante principal + TODOS
 * os add-ons marcados numa só chamada /cart/add.js.
 *
 * Atualização do cart-drawer: usa o render NATIVO do tema. Pede as `sections`
 * na própria chamada /cart/add.js e passa a resposta pro cart.renderContents()
 * — o MESMO caminho do product-form.js. Assim o layout, o estado is-empty, o
 * re-bind de eventos e o featured-collection saem corretos de graça, sem
 * cirurgia manual de DOM (que colapsava a lista de itens do drawer).
 * Nada marcado: não faz nada, o fluxo nativo do tema segue normal.
 */
(function () {
  function init() {
    var box = document.querySelector('[data-wl-combo]');
    if (!box) return;
    var cbs = Array.prototype.slice.call(box.querySelectorAll('[data-wl-combo-cb]'));
    if (!cbs.length) return;

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var submitting = false;

    form.addEventListener('submit', function (e) {
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      var mainId = String(idInput.value);

      // Add-ons marcados, disponíveis e que não são a própria variante principal.
      var picked = cbs.filter(function (cb) {
        return cb.checked
          && cb.getAttribute('data-available') !== 'false'
          && String(cb.getAttribute('data-addon-id')) !== mainId;
      });
      if (!picked.length) return; // nada a somar: fluxo nativo do tema

      e.preventDefault();
      e.stopImmediatePropagation();
      if (submitting) return;

      var qEl = form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"]');
      var qty = qEl ? Math.max(1, parseInt(qEl.value, 10) || 1) : 1;

      // Mesmo alvo que o product-form.js usa pra renderizar o resultado.
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      var btn = form.querySelector('.product-form__submit');
      var spinner = btn ? btn.querySelector('.loading__spinner, .loading-spinner') : null;
      submitting = true;
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      if (spinner) spinner.classList.remove('hidden');

      var items = [{ id: Number(mainId), quantity: qty }];
      picked.forEach(function (cb) {
        items.push({ id: Number(cb.getAttribute('data-addon-id')), quantity: 1 });
      });

      var body = { items: items };
      // Pede as sections renderizadas na própria resposta do add (como o tema faz).
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn || document.activeElement);
      }

      function clearLoading() {
        submitting = false;
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (spinner) spinner.classList.add('hidden');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function (response) {
          clearLoading();
          if (cart && typeof cart.renderContents === 'function' && response.sections) {
            cart.renderContents(response); // render nativo: atualiza drawer + bubble e abre
            // Igual ao product-form.js: garante que o <cart-drawer> perca o is-empty.
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          } else {
            // Sem cart-drawer/sections (ou tema diferente): cai no carrinho cheio.
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          clearLoading();
          // Mostra o motivo real da Shopify (ex.: limite de estoque) em vez de erro genérico.
          var msg = (err && (err.description || err.message)) || 'Erro — tente de novo';
          if (msg.length > 90) msg = msg.slice(0, 87) + '…';
          var lbl = btn ? btn.querySelector('span[data-button-label]') : null;
          if (lbl) { var old = lbl.textContent; lbl.textContent = msg; setTimeout(function () { lbl.textContent = old; }, 4500); }
        });
    }, true);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
